import { CONFIG } from './config'

export const WORDS = [
   'laybi',
  'gadim',
  'wiirr',
  'jaarl',
  'joowa',
  'diyil',
  'diird',
  'riiwa',
  'milji',
  'nilar',
  'odorr',
  'giiji',
  'dirdi',
  'irrol',
  'idarr',
  'miijo',
  'arrin',
  'ayala',
  'goona',
  'ararr',
  'jardo',
  'jagid',
  'iidan',
  'mayar',
  'boora',
  'wardo',
  'balab',
  'dirrb',
  'jamoo',
  'jirrm',
  'injij',
  'jagal',
  'jiiwa',
  'janal',
  'goorr',
  'gooja',
  'alabo',
  'noorr',
  'biiwi',
  'jirra',
  'jarri',
  'gardi',
  'jiibi',
  'balal',
  'wiiji',
  'oombi',
  'joola',
  'anjoo',
  'lolor',
  'boola',
  'ardan',
  'boona',
  'jarro',
  'baadi',
  'gooda',
  'biini',
  'yaaga',
  'gardo',
  'loowa',
  'aalin',
  'aniya',
  'joord',
  'anaya',
  'nimar',
  'goroi',
  'ngami',
  'alaba',
  'iilyi',
  'milal',
  'jalba',
  'manan',
  'jawoo',
  'arran',
  'marra',
  'garra',
  'naawa',
  'loomi',
  'ilgar',
  'jinal',
  'aanja',
  'gaara',
  'garri',
  'jiiya',
  'jamin',
  'inman',
  'jiiba',
  'jardi',
  'jigir',
  'boyin',
  'iinar',
  'oowin',
  'laada',
  'raali',
  'maman',
  'ilayi',
  'biiji',
  'gayar',
  'jarda',
  'waawi',
  'oolab',
  'jarra',
  'jalga',
  'inala',
  'angan',
  'mayon',
  'goori',
  'aalig',
  'goolb',
  'boond',
  'gaarr',
  'jarrb',
  'nagir',
  'doorr',
  'bardo',
  'aarli',
  'nilal',
  'jiido',
  'arron',
  'giido',
  'injin',
  'goord',
  'liyan',
  'ankoo',
  'bajin',
  'alarr',
  'aalga',
  'niidi',
  'boowa',
  'gaari',
  'anala',
  'yoorr',
  'yaarl',
  'gooba',
  'nimal',
  'mamin',
  'jawal',
  'injoo',
  'lanji',
  'biila',
  'jaboo',
  'alala',
  'layab',
  'garrb',
  'aliji',
  'borla',
  'janin',
  'laaga',
  'layar',
  'billy',
  'barda',
  'maank',
  'dooly',
  'norla',
  'ramoo',
  'lalin',
  'aamba',
  'anama',
  'niimi',
  'oolin',
  'noong',
  'wajim',
  'bawin',
  'liibi',
  'anana',
  'gawir',
  'ragal',
  'gooli',
  'booyi',
  'miila',
  'arrab',
  'baali',
  'injal',
  'aralg',
  'rawin',
  'marrg',
  'yaala',
  'doong',
  'anggi',
  'biili',
  'nalma',
  'garrj',
  'diiwa',
  'garda',
  'giija',
  'jiila',
  'andan',
  'damba',
  'jaala',
  'diimb',
  'albay',
  'ngiil',
  'aligi',
  'jabij',
  'jooga',
  'baybi',
  'mayin',
  'abarr',
  'daaba',
  'jagij',
  'gawoo',
  'norlo',
  'gorna',
  'wiira',
  'arang',
  'layib',
  'jirri',
  'inama',
  'jabar',
  'ranan',
  'jaaga',
  'jajoo',
  'goron',
  'bardi',
  'diiji',
  'rarrb',
  'gooly',
  'baank',
  'idool',
  'jalal',
  'amboo',
  'miida',
  'milon',
  'jawij',
  'aaman',
  'larda',
  'jabal',
  'niimo',
  'roong',
  'mayoo',
  'jalan',
  'banka',
  'boolj',
  'goola',
  'moola',
  'joorr',
  'irrma',
  'baarl',
  'jiidi',
  'baawa',
  'aarlo',
  'goowa',
  'naaga',
  'riiji',
  'iilon',
  'inkal',
]

if (CONFIG.normalization) {
  WORDS.forEach((val, i) => (WORDS[i] = val.normalize(CONFIG.normalization)))
}

function shuffle(array: any[]) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[array[i], array[j]] = [array[j], array[i]]
  }
}

if (CONFIG.shuffle) {
  shuffle(WORDS)
}
